import { useTranslation } from "react-i18next";

const OldBringNew = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`promotions.oldBringNewPromotion.content.${key}`);

  return (
    <div className="my-8">
      <p className="text-red-500 font-bold text-2xl">{i18n("title2")}</p>
      <h1 className="text-2xl font-bold mb-6">{i18n("activityRules")}</h1>

      <p className="mb-4">{i18n("rule1")}</p>
      <p className="mb-4">{i18n("rule2")}</p>
      <p className="mb-4">{i18n("rule3")}</p>
      <p className="mb-4">{i18n("rule4")}</p>
      <p className="mb-4">{i18n("rule5")}</p>

      <h1 className="text-2xl font-bold mb-6 ">
        {i18n("specialInstructions")}
      </h1>
      <ul className="list-disc pl-5 mt-2">
        <li className="mb-4">{i18n("instruction1")}</li>
        <li className="mb-4">{i18n("instruction2")}</li>
        <li className="mb-4">{i18n("instruction3")}</li>
        <li className="mb-4">{i18n("instruction4")}</li>
        <li className="mb-4">{i18n("instruction5")}</li>
        {/* <li className="mb-4">{i18n("instruction6")}</li>
        <li className="mb-4">{i18n("instruction7")}</li> */}
      </ul>
    </div>
  );
};

export default OldBringNew;
